<div class="p-grid" [ngClass]="{ behavioranchor: type === SliderTypes.Behavioranchor }">
  <div class="p-col">
    <ngx-slider [(value)]="value" [options]="options" (valueChange)="onValueChange($event)" (userChangeEnd)="onUserChangeEnd($event)"></ngx-slider>
  </div>
  <div class="p-col-fixed p-d-flex p-ai-center p-jc-center label" style="width: 50px" *ngIf="hideValue !== true">
    <span *ngIf="value >= 0">{{ value }}</span>
    <span *ngIf="value < 0">-</span>
  </div>
</div>
